import Loading from "components/atoms/Loading";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { post } from "utils/request";
import { useUserContext } from "components/context/UserContext";
import { useSearchParams } from "react-router-dom";
import { useRouter } from "components/hooks";
import { TOAST_CONFIG } from "../constants";

export default function GoogleSigin() {
  const { setTokenId } = useUserContext();
  const router = useRouter();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get("code");
    const redirectURI = searchParams.get("redirectURI");
    if (code) {
      post(
        "/api/v1/social-media/social-auth/google-handshake",
        {
          google_auth_code: encodeURIComponent(code || ""),
        },
        {
          processData: ({ data }) => {
            setTokenId(data.token);
            router.go(redirectURI || "/");
          },
          processError: (err) => {
            toast.error(err, TOAST_CONFIG);
          },
        },
      );
    }
  }, []);

  return (
    <div className="just fixed top-0 z-40 flex h-[100vh] w-[100vw] items-center bg-primary px-4 py-24 text-white">
      <Loading />
    </div>
  );
}
